import styled from 'styled-components';

const Wrapper = styled.div`
  margin-left: 11px;
  width: 149px;
  ${({ isDisabled }) => isDisabled && 'cursor: not-allowed'};
`;
Wrapper.displayName = 'Wrapper';

export default Wrapper;
